import React, { Component } from "react";
import { API_ENDPOINTS, postRequest } from "../config/apiConfig";

export class DoctorLoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctorCode: "",
      error: "",
      loading: false,
    };
  }

  async handleSubmit() {
    const { doctorCode } = this.state;
    if (!doctorCode.trim()) {
      this.setState({ error: "Please enter your Doctor Code." });
      return;
    }
    this.setState({ loading: true, error: "" });
    try {
      const res = await postRequest(API_ENDPOINTS.DOCTOR_LOGIN, {
        doctor_id: doctorCode.trim(),
      });
      const data = await res.json();
      console.log("Doctor login:", data);

      if (res.ok || data.status) {
        const userdata = Array.isArray(data) ? data[0] : data;
        const user = userdata.data ? userdata.data.Doctor[0] : userdata;

        const loggedUser = {
          personId: user?.DoctorID,
          name: `Dr. ${user?.FirstName || ""} ${user?.LastName || ""}`.trim(),
          email: user?.Email || "",
          role: "doctor",
          doctorId: doctorCode.trim(),
          doctorCode: doctorCode.trim(),
        };

        localStorage.setItem("dg_user", JSON.stringify(loggedUser));
        this.setState({ loading: false });
        if (this.props.onLogin) this.props.onLogin(loggedUser);
      } else {
        this.setState({
          loading: false,
          error: data.message || "Invalid Doctor Code.",
        });
      }
    } catch (err) {
      this.setState({ loading: false, error: "Cannot connect to server." });
    }
  }

  render() {
    const { doctorCode, error, loading } = this.state;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f0f4ff",
          fontFamily: "'Plus Jakarta Sans', 'Outfit', sans-serif",
          padding: 16,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 20,
            padding: "48px 40px",
            width: "100%",
            maxWidth: 400,
            boxShadow: "0 8px 40px rgba(0,0,0,.10)",
            border: "1px solid #e5e7eb",
          }}
        >
          {/* Icon + Title */}
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: 16,
                background: "#EFF6FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1a6ef5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" />
              </svg>
            </div>
            <h1
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: "#0a0f1e",
                margin: 0,
              }}
            >
              Doctor Login
            </h1>
            <p style={{ color: "#6b748c", fontSize: 14, margin: "8px 0 0" }}>
              Enter your Doctor Code to continue
            </p>
          </div>

          {/* Input */}
          <div style={{ marginBottom: 12 }}>
            <label
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#374151",
                display: "block",
                marginBottom: 8,
                textTransform: "uppercase",
                letterSpacing: ".5px",
              }}
            >
              Doctor Code
            </label>
            <input
              type="text"
              value={doctorCode}
              onChange={(e) =>
                this.setState({ doctorCode: e.target.value, error: "" })
              }
              onKeyDown={(e) => e.key === "Enter" && this.handleSubmit()}
              placeholder="e.g. DG1"
              autoFocus
              style={{
                width: "100%",
                height: 50,
                padding: "0 16px",
                border: `1.5px solid ${error ? "#ef4444" : "#e5e7eb"}`,
                borderRadius: 12,
                fontSize: 15,
                fontFamily: "inherit",
                outline: "none",
                boxSizing: "border-box",
                color: "#0a0f1e",
                transition: "border-color .15s",
              }}
              onFocus={(e) => {
                if (!error) e.target.style.borderColor = "#1a6ef5";
              }}
              onBlur={(e) => {
                if (!error) e.target.style.borderColor = "#e5e7eb";
              }}
            />
            {error && (
              <p style={{ color: "#ef4444", fontSize: 12, margin: "6px 0 0" }}>
                {error}
              </p>
            )}
          </div>

          {/* Button */}
          <button
            onClick={() => this.handleSubmit()}
            disabled={loading}
            style={{
              width: "100%",
              height: 50,
              borderRadius: 12,
              border: "none",
              background: loading ? "#93c5fd" : "#1a6ef5",
              color: "#fff",
              fontSize: 15,
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "inherit",
              marginTop: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {loading ? "Verifying…" : "Open Doctor Dashboard →"}
          </button>
        </div>
      </div>
    );
  }
}

export default DoctorLoginPage;
